import React from "react";

function Header() {
  return (
    <header>
      <h1>Emoji Search😀</h1>
    </header>
  );
}

export default Header;
